// src/pages/cashier/ContinentalCashierDashboard.jsx
import React from 'react';
import CashierDashboard from '../CashierDashboard';

const ContinentalCashierDashboard = () => {
  return <CashierDashboard locationKey="continental" />;
};

export default ContinentalCashierDashboard;